module.exports = __webpack_public_path__ + "img/linkedin.4476cd34.png";